import { useMediaQuery } from "@helmr/ui";
import { PHONE_QUERY } from "../../../app/mobile/query";
import { HomePage } from "../HomePage";
import { MobileHome } from "./MobileHome";

/** `/home` on a phone is the mobile Home; from 768px up it is app-shell-home's page, unchanged. Same hooks either way. */
export function HomeSwitch() {
  return useMediaQuery(PHONE_QUERY) ? <MobileHome /> : <HomePage />;
}
